<template>
    <div>
        <v-dialog :value="value" :width="850" @input="handlePopup">
            <v-card class="pa-6 text-left" min-height="">
                <v-row class="mb-4">
                    <v-col class="py-0">
                        <h4 class="q-display-1 pa-5 white--text text-center q_leads_1">Transfer {{ error ? 'Unsuccessful' : 'Successful' }}
                        </h4>
                    </v-col>
                </v-row>
                <v-row v-if="error" justify="space-around" align="center">
                    <strong>Error Message:</strong>
                    <p>{{ error }}</p>
                </v-row>
                <v-row justify="center">
                    <v-btn @click="handlePopup(false)">Ok</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        error: {
            type: String,
            default: "",
        },
    },
    methods: {
        handlePopup(value) {
            this.$emit('input', value)
        },
    },
}
</script>
